module.exports = __webpack_public_path__ + "img/signup-carousel-third@3x.8e239d42.png";